import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
const SEARCH_THUMBNAIL_HEIGHT = 48;
const SEARCH_THUMBNAIL_WIDTH = 60;
export default function ThemeSearchBarResult({
  companyName,
  name,
  thumbnailUrl
}) {
  return /*#__PURE__*/_jsx(UIMediaObject, {
    itemLeft: /*#__PURE__*/_jsx(UIFlex, {
      style: {
        height: SEARCH_THUMBNAIL_HEIGHT,
        width: SEARCH_THUMBNAIL_WIDTH
      },
      children: /*#__PURE__*/_jsx(UIImage, {
        src: thumbnailUrl,
        style: {
          maxHeight: '100%'
        }
      })
    }),
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(UIFlex, {
        children: /*#__PURE__*/_jsx("span", {
          className: "is--heading-7 m-bottom-1",
          children: name
        })
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.assets.themeSearchBarResult.companyName",
          options: {
            companyName
          }
        })
      })]
    })
  });
}